import React from 'react';
import { CheckCircle, User } from 'lucide-react';
import { useFlowNavigation, useFlow } from '../../../contexts/FlowContext';
import { useTheme, useMessages } from '../../../contexts/ThemeContext';
import SessionExpiryModal from '../../../components/modals/SessionExpiryModal';

const ConfirmationPage: React.FC = () => {
  const { nextStep } = useFlowNavigation();
  const { getFlowData, completeStep, currentStep } = useFlow();
  const { theme } = useTheme();
  const messages = useMessages();
  
  const newUsername = getFlowData('newUsername') || '';
  const webadUsername = getFlowData('webadUsername') || '';

  const handleConfirm = () => {
    if (currentStep) {
      completeStep(currentStep.id);
    }
    nextStep();
  };

  return (
    <div className="container">
      <CheckCircle size={48} className="icon" style={{ color: theme.colors?.success || '#28a745', marginBottom: '1rem' }} />
      
      <h1>Confirm Username Change</h1>
      
      <div style={{
        backgroundColor: theme.colors?.light || '#f8f9fa',
        border: `1px solid ${theme.colors?.border || '#dee2e6'}`,
        borderRadius: theme.borderRadius?.md || '8px',
        padding: theme.spacing?.lg || '1.5rem',
        marginBottom: theme.spacing?.lg || '1.5rem'
      }}>
        <div style={{ marginBottom: '1rem' }}>
          <strong>Authenticated as:</strong>
          <div style={{ 
            fontSize: '1.1rem', 
            color: theme.colors?.primary || '#0066cc',
            marginTop: '0.5rem'
          }}>
            <User size={16} style={{ display: 'inline', marginRight: '0.5rem' }} />
            {webadUsername}
          </div>
        </div>
        
        <div>
          <strong>New Username:</strong>
          <div style={{ 
            fontSize: '1.1rem', 
            color: theme.colors?.success || '#28a745',
            marginTop: '0.5rem',
            fontWeight: 'bold'
          }}>
            {newUsername}
          </div>
        </div>
      </div>

      <p style={{ marginBottom: theme.spacing?.lg || '1.5rem' }}>
        Please review the information above and confirm that you want to proceed with this username change.
      </p>

      <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
        <button 
          onClick={handleConfirm}
          style={{
            backgroundColor: theme.colors?.primary || '#0066cc',
            color: '#ffffff',
            padding: '0.75rem 2rem',
            border: 'none',
            borderRadius: theme.borderRadius?.md || '8px',
            fontSize: '1rem',
            cursor: 'pointer',
            fontWeight: '500'
          }}
        >
          {messages.ui?.usernameChange?.submitButton || 'Confirm Change'}
        </button>
      </div>
      <SessionExpiryModal />
    </div>
  );
};

export default ConfirmationPage;
